import { SvgIcon, type SvgIconProps } from '@mui/material';

import { ReactComponent as FlowCompassLogo } from '../../scenes/AgenticChat/Assets/flow-compass.svg';

export function AgenticChatLogo(props: SvgIconProps) {
  return <SvgIcon component={FlowCompassLogo} inheritViewBox {...props} />;
}
